import { useCallback, useEffect, useState } from "react";
import {
  TESTIMONIALS_CHANGED_EVENT,
  getTestimonials
} from "../services/testimonialService";

function useTestimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    setError("");
    try {
      const records = await getTestimonials();
      setTestimonials(records);
      return records;
    } catch (refreshError) {
      const message = refreshError.message || "Failed to load testimonials.";
      setError(message);
      return [];
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    let isMounted = true;

    const runRefresh = async () => {
      const records = await getTestimonials().catch((refreshError) => {
        if (isMounted) {
          setError(refreshError.message || "Failed to load testimonials.");
        }
        return [];
      });

      if (isMounted) {
        setTestimonials(records);
        setIsLoading(false);
      }
    };

    runRefresh();

    const sync = () => {
      refresh();
    };

    window.addEventListener(TESTIMONIALS_CHANGED_EVENT, sync);
    window.addEventListener("storage", sync);

    return () => {
      isMounted = false;
      window.removeEventListener(TESTIMONIALS_CHANGED_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, [refresh]);

  return { testimonials, refresh, isLoading, error };
}

export default useTestimonials;
